import React, { Component } from 'react';
import Highcharts from 'highcharts/highstock'
import HighchartsReact from 'highcharts-react-official'
import { withRouter } from 'react-router-dom';
//import queryString from 'query-string';

import {api_host} from '../../../../../common/globals/constants';
import CircularProgress from '@material-ui/core/CircularProgress';
// Shared components
import PortletContent from 'components/PortletContent';

import Typography from '@material-ui/core/Typography';
import PerfectScrollbar from 'react-perfect-scrollbar';
import {getResponseGeneral} from '../../../../../services/getTimeResponseGeneral'
import {getResponseObjective} from '../../../../../services/getResponseObjective'
import moment from 'moment'
import 'moment/locale/es'  
moment.locale('es')

class ResponseTimeGeneralDay extends Component {
    
    constructor(props) {
        super(props);
        //console.log('response',props)
        //const begin=moment().subtract(3, 'days')._d
        //const final= moment().subtract(1, "days")._d
            
        this.state = {
            currentObjectiveId: this.props.location.state.fromObjective.objetivo_id,
            loadObjectiveData: false,
            period: this.props.data.period,
            externalData: null,
            dataError: false,
            isLoading: true,
            sla: null,
            time: 'c',
            hoverData: null,
            lastEvent: [],
            statePeriod: this.props.data.range,
        }  
    }

    static getDerivedStateFromProps(props, state) {
        //console.log('derived', moment(props.data.range.startDate).format("Y-MM-DD"), moment(state.statePeriod.startDate).format("Y-MM-DD"))
        //console.log(props.data.range.endDate,state.finalDate)
        if( moment(props.data.range.startDate).format("Y-MM-DD")!==moment(state.statePeriod.startDate).format("Y-MM-DD")){
            return{
                statePeriod:props.data.range,
                isLoading:true,
            }    
        }
        return null
    }

    componentDidMount() {
        this.getDataFromAPI();
    }

    componentDidUpdate(prevProps, prevState) {
        if (moment(prevProps.data.range.startDate).format("Y-MM-DD")!==moment(this.state.statePeriod.startDate).format("Y-MM-DD")) {
            this.getDataFromAPI();
        }

    }
    

    getDataFromAPI = () => {  
        const { currentObjectiveId,period, statePeriod } = this.state
        const { fromObjective } = this.props.location.state
        //console.log(fromObjective)
        let sla_rendimiento_ok = parseInt(fromObjective.sla_rendimiento_ok)
        let sla_rendimiento_error = parseInt(fromObjective.sla_rendimiento_error)
        let sla_disponibilidad_ok = parseInt(fromObjective.sla_disponibilidad_ok)
        let sla_disponibilidad_error = parseInt(fromObjective.sla_disponibilidad_error)
        let fecha_inicio = null
        let fecha_termino = null
        let token = sessionStorage.getItem('key')
        //console.log(statePeriod)
        if (period === 'c') {
            fecha_inicio = statePeriod.startDate.toISOString().substring(0, 10)
            fecha_termino = statePeriod.endDate.toISOString().substring(0, 10)
            //console.log(currentObjectiveId,token,fecha_inicio,fecha_termino)
            getResponseGeneral(currentObjectiveId,token,fecha_inicio,fecha_termino).then(data => {
                if (data.status == 1 || data.status == 5) {
                    localStorage.setItem('isAuthenticated', false);                        
                } else {
                    //Procesa la Data Recibida
                    try {
                        //console.log('  va a process')
                        this.processData(data.Objetivo, sla_rendimiento_ok,
                                sla_rendimiento_error,
                                sla_disponibilidad_ok,
                                sla_disponibilidad_error,
                                period,
                                fecha_inicio,
                                fecha_termino)
                    } catch (error) {
                        //console.log('error')
                        this.setState({
                            dataError: true,
                            isLoading: false
                        });
                    }
                }  
            })
        }
    }

    // Helper para procesar la data de la petición a la API

    processData = (externalData,
        sla_rendimiento_ok,
        sla_rendimiento_error,
        sla_disponibilidad_ok,
        sla_disponibilidad_error,
        period,
        fecha_inicio,
        fecha_termino) => {
        let lastEventDict = []
        //console.log('process',externalData)
        const colors = ['#2199e8', '#fed12d', '#ff7373', '#ccff00', '#b6fcd5',
            '#065535', '#ffc0cb', '#008080', '#00ffff', '#ffa500',
            '#800000', '#fff68f', '#bada55', '#8a2be2', '#3b5998'];
        var tittle=externalData.Objetivo_nombre
        var listStepDays=[]
        externalData.Paso.map(paso=>{
            //console.log(paso.paso_nombre)
            const groups = paso.rendimientoDetalle.reduce((groups, game) => {
                var date=parseInt(moment(game.inicio).day())
                if (!groups[date]) {
                  groups[date] = [];
                }
                groups[date].push(game);
                return groups;
              }, {});
            var listDays=[]
            Object.keys(groups).map(ele=>{
                var time=0
                var time12=0
                var cont=0
                var cont12=0
                //console.log(groups[ele])
                groups[ele].map(data=>{
                    var dayTime=parseInt(((((data.inicio).split("T"))[1]).split(":"))[0])
                    //console.log(dayTime)
                    if(dayTime===0){
                        time=time+data.respuesta
                        cont=cont+1
                    }
                    if(dayTime===12){
                        time12=time12+data.respuesta
                        cont12=cont12+1
                    }
                })
                listDays.push(parseFloat((time/cont).toFixed(2)))
                listDays.push(parseFloat((time12/cont12).toFixed(2)))
            })
            
            listStepDays.push({'name':paso.paso_nombre, 'data':listDays, 'marker': {'enabled': true,'radius':2,},})
        })
        //console.log(listStepDays)
        this.setState({
            chartOptions: {
                // title:"",
                title: {
                    text: '',
                    style: {
                        fontSize: '' 
                     }
                },
                xAxis: {
                    labels: {
                        formatter: function() {
                            if(!this.value){
                                return '';
                            }
                            var nombre = this.value.split(' ');
                            return '<b>'+nombre[0]+'</b>';
                        },
                    },
                    tickPositions: [0, 2, 4,6, 8,10,12],
                    categories: ['Domingo 00:00:00','Domingo 12:00:00','Lunes 00:00:00','Lunes 12:00:00','Martes 00:00:00','Martes 12:00:00',
                                'Miercoles 00:00:00','Miercoles 12:00:00','Jueves 00:00:00','Jueves 12:00:00','Viernes 00:00:00','Viernes 12:00:00',
                                'Sabado 00:00:00','Sabado 12:00:00']
                },
                tooltip: {
                    style: { fontSize: '11px' },
                    backgroundColor:'rgba(255,255,255,1)',
                    formatter: function() {
                        return '<b>'+this.series.name+'</b><br/>'+
                               '<b>Fecha :</b> '+ this.x+'<br/>'+
                               '<b>Tiempo de Respuesta :</b> '+Highcharts.numberFormat(this.y,2,',')+' [s]';
                    },
                },
                yAxis: {
                    title: {
                        style: { color: '#5A5A5A' },
                        text: 'Tiempo de Respuesta [s]'
                    },
                    labels: {
                        formatter: function() {
                            if(this.value % 1 != 0)
                                return this.value.toFixed(2);
                            else
                                return this.value;
                            },
                    },
    
                    gridLineWidth: 0.3,
                    min:0,
                    lineWidth:1,
                },
                
                credits: {
                    enabled: false
                },
                series: listStepDays,
            },
            dataError: false,
            isLoading: false,
            lastEvent: lastEventDict,
            time: period
        });

    }
    render() {
        const { dataError, chartOptions, isLoading } = this.state;
        //console.log('render',dataError, isLoading)
        if (!dataError) {
            if(isLoading===true){
                return (
                    <PortletContent>
                        <PerfectScrollbar>
                            <Typography
                                variant="h5"
                                >
                                <CircularProgress
                                variant="indeterminate"
                                size={24}
                                thickness={4}                            
                                />
                                <br/>
                                Cargando Información...
                            </Typography>
                        </PerfectScrollbar>
                    </PortletContent>
                )
            }else{
                sessionStorage.setItem("chartResponseTimeGeneralDay",JSON.stringify(chartOptions))
                return(
                    <HighchartsReact
                        highcharts={Highcharts}
                        options={chartOptions} 
                    />
                )
            }
        }
        else if (dataError) {
            return (<p>No hay datos..</p>)
        }
        else return (<p>Error!</p>)

    }
}


export default withRouter(ResponseTimeGeneralDay);